App.factory('Institution', restmod => {
    return restmod.model('/institutions')
})
